import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './question.css';
import { faPeopleGroup, faXmark } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { useState } from 'react';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

const Question = ({ text }) => {

    const [collabModalIsOpen, setCollabModalIsOpen] = useState(false);

    const openCollabModal = () => {
        console.log('openCollabModal called');
        // alert('openCollabModal called');
        setCollabModalIsOpen(true);
    };
    const closeCollabModal = () => {
        setCollabModalIsOpen(false);
    };





    return (
        <div className="question">
            <p>{text}</p> 
            {/* <button className='collab-btn' title="Invite a collaborator to answer this question" onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                openCollabModal();
            }}><FontAwesomeIcon icon={faPeopleGroup}></FontAwesomeIcon></button> */}
            <Modal
                isOpen={collabModalIsOpen}
                // onAfterOpen={afterOpenModal}
                onRequestClose={closeCollabModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className='collab-modal'>
                    <div className='close-btn-wrapper'>
                        <span className='modal-close-span' onClick={closeCollabModal}>X</span>
                    </div>
                    <h2>Invite a Collaborator</h2>
                    <p>Share the following question with a team member to gather their insight for the following question:</p>
                    <p className='collab-question-text'>{text}</p>
                    <form>
                        <label htmlFor="email">Email:</label>
                        <input type="email" id="email" name="email" required placeholder='Collaborator@yourcity.gov'/>
                        <button type="submit" className='collab-send-btn'>Send Invite</button>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

export default Question;